import { create } from "zustand";

/* * This store manages the state of the team session in the app. */
interface TeamState {
  teamName?: string | undefined;
  setTeamName: (teamName: string | undefined) => void;
  shareUrl?: string | undefined;
  setShareUrl: (shareUrl: string | undefined) => void;
  shareText?: string | undefined;
  setShareText: (shareText: string | undefined) => void;
}

export const useTeamState = create<TeamState>((set) => ({
  teamName: undefined,
  setTeamName: (teamName) => {
    set({ teamName });
  },
  shareUrl: undefined,
  setShareUrl: (shareUrl) => {
    set({ shareUrl });
  },
  shareText: undefined,
  setShareText: (shareText) => {
    set({ shareText });
  },
}));
